










import { Component, Prop, Vue } from 'vue-property-decorator'
import Wallet from '@/components/Wallet.vue'

@Component({
  components: {
    Wallet,
  },
})
export default class App extends Vue {
  private title = 'NEM wallet'
}
